(() => {
  const TIERS = [
    { threshold: 15000, id: 40955008647361, name: 'CHOUCHOU - Black Large', value: 3000, image: 'https://cdn.shopify.com/s/files/1/0597/4589/4593/products/black_large_800.jpg?v=1635411285' },
    { threshold: 35000, id: 50802909118657, name: 'SÉRÉNITÉ CANDLE', value: 4800, image: 'https://cdn.shopify.com/s/files/1/0597/4589/4593/products/Serenite_Beauty.jpg?v=1669191700' }
  ];
  const GIFT_PROPERTY = '_branche_complimentary_gift';
  const nativeFetch = window.fetch.bind(window);

  let syncing = false;
  let queued = false;
  let blockedCart = '';
  try { blockedCart = sessionStorage.getItem('branche-gift-blocked-cart') || ''; } catch (_) {}
  const root = window.Shopify?.routes?.root || '/';
  let timer = null;

  const money = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: cents % 100 ? 2 : 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const isTaggedGift = (item) => {
    return item.properties &&
      String(item.properties[GIFT_PROPERTY]) === 'true';
  };


  const qualifyingTotal = (cart) => {
    return cart.items.reduce((total, item) => {
      if (isTaggedGift(item) || Number(item.variant_id) === TIERS[1].id || item.product_title === 'CHOUCHOU  - Multi Large') return total;
      return total + Number(item.final_line_price || 0);
    }, 0);
  };

  const updateProgress = (cart) => {
    const total = qualifyingTotal(cart);
    const tier = total >= 15000 ? TIERS[1] : TIERS[0];
    const remaining = Math.max(0, tier.threshold - total);
    const percent = Math.min(100, Math.max(0, total / tier.threshold * 100));
    document.querySelectorAll('[data-branche-gift-progress]').forEach((bar) => {
      const message = bar.querySelector('[data-branche-gift-message]');
      const title = bar.querySelector('.branche-gift-progress__eyebrow');
      const value = bar.querySelector('.branche-gift-progress__value');
      const detail = bar.querySelector('.branche-gift-progress__detail');
      const image = bar.querySelector('.branche-gift-progress__thumb img');
      const fill = bar.querySelector('[data-branche-gift-fill]');
      const progress = bar.querySelector('[role="progressbar"]');
      if (title) title.textContent = 'FREE GIFT WITH ' + money(tier.threshold,cart.currency) + '+';
      if (value) value.textContent = money(tier.value,cart.currency) + ' VALUE';
      if (image && image.dataset.giftTier !== String(tier.id)) {
        image.removeAttribute('srcset');
        image.src = tier.image;
        image.alt = tier.name + ' complimentary gift';
        image.dataset.giftTier = String(tier.id);
      }
      const giftsPresent = cart.items.some(i => Number(i.variant_id) === TIERS[1].id && i.final_line_price === 0);
      if (message) message.textContent = total >= 35000
        ? (giftsPresent ? 'Your complimentary scrunchie and Sérénité candle are added!' : 'You have unlocked your complimentary scrunchie and Sérénité candle.')
        : total >= 15000
          ? 'Your free scrunchie is unlocked! Spend ' + money(remaining,cart.currency) + ' more for a complimentary Sérénité candle.'
          : "You're " + money(remaining,cart.currency) + ' away from a complimentary CHOUCHOU - Black Large.';
      if (detail) detail.textContent = total >= 15000
        ? 'Keep your free scrunchie. Your candle is automatically added at $350. One of each gift per order.'
        : 'Automatically added to your cart when you spend $150. One gift per order.';
      if (fill) fill.style.width = percent + '%';
      if (progress) {
        progress.setAttribute('aria-valuemax', String(tier.threshold / 100));
        progress.setAttribute('aria-valuenow', String(Math.min(total,tier.threshold) / 100));
        progress.setAttribute('aria-label','Progress toward complimentary ' + tier.name);
      }
    });
  };

  const getCart = async () => {
    const response = await nativeFetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  };

  const addGift = async (tier) => {
    const response = await nativeFetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: tier.id,
          quantity: 1,
          properties: {
            [GIFT_PROPERTY]: 'true',
            'Complimentary Gift': 'Spend $' + tier.threshold / 100
          }
        }]
      })
    });

    if (!response.ok) throw new Error('Unable to add complimentary gift');
  };

  const removeGift = async (itemKey) => {
    const response = await nativeFetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    });

    if (!response.ok) throw new Error('Unable to remove complimentary gift');
  };

  const announceCartChange = async (cart) => {
    if (window.themeVariables?.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true,detail:{sections}}));
    cart.sections = {};
    if (sections.length) {
      const response = await nativeFetch(root + '?sections=' + encodeURIComponent([...new Set(sections)].join(',')));
      if (!response.ok) throw new Error('Unable to refresh the cart');
      cart.sections = await response.json();
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles:true, detail:{baseEvent:'branche:complimentary-gift',cart}
    }));
  };

  const fingerprint = cart => JSON.stringify(cart.items.filter(i => !isTaggedGift(i) && Number(i.variant_id) !== TIERS[1].id).map(i => [i.variant_id,i.quantity,i.final_line_price]));

  const syncGift = async () => {
    if (syncing) { queued = true; return; }
    syncing = true;
    let changed = false;
    let cart;
    try {
      cart = await getCart();
      const total = qualifyingTotal(cart);
      const desired = total >= 35000 ? TIERS[1] : total >= 15000 ? TIERS[0] : null;
      const signature = fingerprint(cart);
      // The higher tier is ONE Shopify fixed bundle containing one of each gift.
      // This replaces the lower gift line without granting a second scrunchie.
      let kept = false;
      for (const item of cart.items) {
        if (!isTaggedGift(item) && Number(item.variant_id) !== TIERS[1].id) continue;
        if (desired && Number(item.variant_id) === desired.id && !kept && item.quantity === 1) {
          kept = true;
        } else {
          await removeGift(item.key);
          changed = true;
        }
      }
      if (desired && !kept && signature !== blockedCart) {
        await addGift(desired);
        changed = true;
      }
      cart = await getCart();
      // Never leave an automatically added reward at a payable price.
      const payableGifts = cart.items.filter(i => (isTaggedGift(i) || Number(i.variant_id) === TIERS[1].id) && i.final_line_price > 0);
      if (payableGifts.length) {
        blockedCart = signature;
        try { sessionStorage.setItem('branche-gift-blocked-cart', signature); } catch (_) {}
        for (const item of payableGifts) { await removeGift(item.key); changed = true; }
        cart = await getCart();
      }
      updateProgress(cart);
      if (desired && blockedCart === signature) {
        document.querySelectorAll('[data-branche-gift-message]').forEach(el => {el.textContent = 'Your current cart or discounts could not qualify for the complimentary gift. No gift charge has been added.';});
      }
      if (changed) await announceCartChange(cart);
    } catch (error) {
      console.warn('[Branché complimentary gift]', error);
    } finally {
      syncing = false;
      if (queued) { queued = false; scheduleSync(); }
    }
  };

  const scheduleSync = (delay = 180) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncGift, delay);
  };

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    try {
      const request = args[0];
      const url = typeof request === 'string'
        ? request
        : request && request.url
          ? request.url
          : '';

      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) {
        scheduleSync();
      }
    } catch (error) {}

    return response;
  };

  document.documentElement.addEventListener('cart:change', (event) => {
    const cart = event.detail && event.detail.cart;
    if (cart) updateProgress(cart);

    if (!event.detail || event.detail.baseEvent !== 'branche:complimentary-gift') {
      scheduleSync(120);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleSync(0), { once: true });
  } else {
    scheduleSync(0);
  }

  window.addEventListener('pageshow', () => scheduleSync(0));
})();